import api from "../../../service/api"

export const AssignClaim = async (data) => {
    let path = `claim/auto-assign-claim/`
    return api.post(path,data)
}

export const getAssignedClaimList = async (queryString) => {
    let path = `claim/user-claims-list/?${queryString}`;
    return api.get(path);
};

export const claimStatusChange = async (payload) => {
    let path = `claim/claim-start-in-progress/`
    return api.post(path,payload)
}